import type { StyledComponentProps } from '@material-ui/core/styles';

import type { PaginationType } from './components/ProductTable';
import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

export const tabs = ['Todos', 'Aprovados', 'Em Análise', 'Reprovados'];

export enum TabsIndexes {
  ALL = 0,
  APPROVED = 1,
  PENDING = 2,
  REPROVED = 3,
  COPRODUCTIONS = 4,
  IRREGULAR = 5,
}

export interface IRouteParams {
  tab?: any;
}

export interface IPropsFromConnect {
  products: any;
  pagination: any;
  irregularProducts: IrregularProduct[];
  isFetching: any;
  childrenOpen: any;
  listProductsChildren: any;
  isCompleted: any;
  currentUser: any;
}

export interface MyContentsProps extends DispatchProp<any>, IPropsFromConnect, StyledComponentProps, RouteComponentProps<IRouteParams> {}

export interface MyContentsState {
  viewType: any;
  tab: any;
  activeMenu: null;
  activeQuickView: boolean;
  filters: { moderation_status: string; status: string; order: string };
  idProduct: number;
  searchValue: string;
  collapseExpanded: number;
  dataProduct: any;
  dataActivatedChildren: any;
}

export type TableType = {
  products: any;
  order: any;
  listChildren: any;
  onSort: any;
  onClickOptions: any;
  isLoading: boolean;
  pagination: PaginationType;
};

export type IrregularProduct = {
  id: number;
  parent_product?: number;
  title: string;
  image: string;
  image_id: number;
  status: 'active' | 'inactive' | 'filed' | ' ';
  active: number;
  producer_id: number;
  has_children: boolean;
  pending_actions: {
    above_coproducers_limit: boolean;
    above_commission_limit: boolean;
    commission_by_value: boolean;
    invalid_physical_dimensions: boolean;
  } | null;
};
